import "../css/About.css"

export const About = () => {

    return <div>
    <div className="about-container">
        <div className="text-image-container">
            <div className="about-text">
            <h2>Hi! My name is <b style={{color: "rgb(124, 25, 25)"}}>Solveiga.</b></h2>
            <h2>I am a junior software developer and a Northcoders Bootcamp Graduate.</h2>
            <p>I have always been curious, loved learning new things and embarking on new challenges. Last year, I have discovered coding and I liked it so much, that I have decided to change my career path!</p>
            <p>I have finally found an occupation that combines my two inherent traits: love for <b>creativity</b> and <b>meticulousness</b>.</p>
<p>After completing freeCodeCamp Responsive Web Design and JavaScript Algorithms and Data Structures courses, I joined <a href="https://northcoders.com/our-courses/coding-bootcamp?utm_term=northcoders&utm_campaign=Brand&utm_source=adwords&utm_medium=ppc&hsa_acc=5738903014&hsa_net=adwords&hsa_cam=14960254281&hsa_ad=553476276203&hsa_kw=northcoders&hsa_grp=135291806144&hsa_mt=p&hsa_ver=3&hsa_src=g&hsa_tgt=kwd-399711163914&gclid=Cj0KCQjwj7CZBhDHARIsAPPWv3d2jN92kfTyeq6A2qL4vL5hOYzt1StAbFrkHvhIdKqe_ij77I4NsYgaAlL5EALw_wcB" rel="noreferrer" target="_blank">Northcoders Bootcamp</a> to become a software developer. The curriculum covered JavaScript, back-end and front-end. During the course, I produced two solo projects and worked on a group project.</p>
            </div>
        </div>
        <div>
            <h3>TECH STACK:</h3>
            <div>
            <ul className="list">
                <li className="card card1"><code>JavaScript</code></li>
                <li className="card card2"><code>Node.js</code></li>
                <li className="card card3"><code>Express.js</code></li>
                <li className="card card4"><code>Jest</code></li>
                <li className="card card3"><code>PostgreSQL</code></li>
                <li className="card card2"><code>React.js</code></li>
                <li className="card card1"><code>HTML</code></li>
                <li className="card card4"><code>CSS</code></li>
            </ul>
            </div>
        </div>
        <div className="resume-container">
            <p>Having succeeded in a variety of roles and industries, I know that in time I will excel in this vocation too.</p>
            <p>For more information, please <a href="/contact"d>get in touch.</a></p>
        </div>       
    </div>
    </div>
}